import gql from 'graphql-tag'
export const fetchAddToFullOrderMutation = gql(`
mutation ($sku: String! , $removeItems: Boolean) {
    quickOrder(
        input:{
            sku: $sku,
            removeItems: $removeItems
        }
    ){
        success_message
        cart_id
    }
}`)
